import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=ff1c23ac&scoped=true&lang=pug"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=ff1c23ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1c23ac",
  null
  
)

export default component.exports